// test2884
(2884 && 0);
